var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.61 2.35973L10.84 4.13973C10.1616 3.95769 9.44724 3.9575 8.76875 4.13917C8.09026 4.32084 7.47157 4.67796 6.9749 5.17463C6.47824 5.6713 6.12111 6.28999 5.93944 6.96848C5.75777 7.64697 5.75796 8.36133 5.94 9.03973L3.18 11.7897C1.86 10.7897 0.76 9.48973 0 7.99973C1.14092 5.76256 3.01299 3.98314 5.30513 2.95713C7.59727 1.93113 10.1715 1.72032 12.6 2.35973H12.61ZM16.41 4.20973C17.74 5.20973 18.84 6.50973 19.61 7.99973C18.4683 10.241 16.593 12.0233 14.2966 13.0496C12.0001 14.0759 9.42136 14.2842 6.99 13.6397L8.76 11.8597C9.43839 12.0418 10.1528 12.042 10.8312 11.8603C11.5097 11.6786 12.1284 11.3215 12.6251 10.8248C13.1218 10.3282 13.4789 9.70947 13.6606 9.03098C13.8422 8.35248 13.842 7.63812 13.66 6.95973L16.42 4.20973H16.41ZM16.16 0.219727L17.58 1.63973L3.44 15.7797L2.02 14.3597L16.16 0.219727Z",
    fill: "#D3DADD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.fd58b964a5127a2b32737cc65735f32c.svg";
export { ForwardRef as ReactComponent };